import { usePathParam } from '@atlassian/react-resource-router';
import {
	type VersionTabId,
	ALL_ISSUES_TAB,
	WARNINGS_TAB,
	DONE_TAB,
	IN_PROGRESS_TAB,
	TODO_TAB,
} from '../../types/tabs/index.tsx';

export type CurrentTabHookResults = {
	currentTabId: VersionTabId;
	setCurrentTab: (tabId: VersionTabId) => void;
};

const toVersionTabId = (selectedTabId?: string): VersionTabId => {
	if (selectedTabId === undefined) return ALL_ISSUES_TAB;

	switch (selectedTabId) {
		case WARNINGS_TAB:
			return WARNINGS_TAB;
		case ALL_ISSUES_TAB:
			return ALL_ISSUES_TAB;
		case DONE_TAB:
			return DONE_TAB;
		case IN_PROGRESS_TAB:
			return IN_PROGRESS_TAB;
		case TODO_TAB:
			return TODO_TAB;
		default:
			return ALL_ISSUES_TAB;
	}
};

export const useCurrentTab = (): CurrentTabHookResults => {
	const [selectedTabId, setSelectedTab] = usePathParam('tab');
	const setCurrentTab = (tabId: VersionTabId) => {
		setSelectedTab(tabId);
	};

	return { currentTabId: toVersionTabId(selectedTabId), setCurrentTab };
};
